import {Message} from 'element-ui';
export const handleCopy = (text) => {
  try {
    // 创建一个隐藏的 textarea 元素
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    // 选择 textarea 中的文本
    textarea.select();
    // 执行复制命令
    document.execCommand('copy');
    // 移除 textarea 元素
    document.body.removeChild(textarea);
    Message.success('复制成功');
  } catch (err) {
    console.log('复制到剪切板失败:', err);
  }
};
// 本地存取
export const Storage = {
  set: function (key, value) {
    if (!key || !value) {
      return;
    }
    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }
    sessionStorage.setItem(key, value);
  },
  get: function (key) {
    var value = sessionStorage.getItem(key);
    if (!value) {
      return;
    }
    // 判断是否是JSON对象
    if (value[0] === '{') {
      value = JSON.parse(value);
    }
    return value;
  },

  remove: function (key) {
    if (!key) {
      return;
    }
    sessionStorage.removeItem(key);
  }
};

export const clearFormData = (obj) => {
  const keys = Object.keys(obj);
  keys.forEach((key) => {
    if (Array.isArray(obj[key])) {
      // 数组类型清空为 []
      obj[key] = [];
    } else if (typeof obj[key] === 'object' && obj[key] !== null) {
      // 对象类型递归清空
      clearFormData(obj[key]);
    } else if (typeof obj[key] === 'boolean') {
      // 布尔类型清空为 false
      obj[key] = false;
    } else {
      // 其他类型清空为 ''
      obj[key] = '';
    }
  });
};

// 递归查找指定 id 的路径
export const findPathById = (tree, targetId) => {
  if (!tree || !Array.isArray(tree)) {
    return null;
  }

  const stack = tree.map((node) => ({
    node,
    path: [node.value]
  }));

  while (stack.length > 0) {
    const {node, path} = stack.pop();
    if (node.value === targetId) {
      return path;
    }

    if (node.children && node.children.length > 0) {
      for (let i = node.children.length - 1; i >= 0; i--) {
        const child = node.children[i];
        stack.push({
          node: child,
          path: [...path, child.value]
        });
      }
    }
  }
  return null;
};

// 将金额字符串转换为最小单位（分）的整数
export const toCents = (moneyStr) => {
  if (!moneyStr && moneyStr !== 0) {
    return 0;
  }
  const str = String(moneyStr);
  const parts = str.split('.');
  const integerPart = parseInt(parts[0], 10) || 0;
  let decimalPart = 0;

  if (parts.length > 1) {
    const decStr = parts[1];
    // 补齐两位小数，例如 "0.1" -> "10", "0.12" -> "12"
    const paddedDec = decStr.padEnd(2, '0').substring(0, 2);
    decimalPart = parseInt(paddedDec, 10);
  }

  // 处理负数情况
  const sign = str.startsWith('-') ? -1 : 1;
  return sign * (Math.abs(integerPart) * 100 + decimalPart);
};
